import * as React from 'react';

import EmptyStatePreviewActivity140 from './EmptyStatePreviewActivity140';

export const emptyStatePreviewActivity140 = () => <EmptyStatePreviewActivity140 />;

export default {
    title: 'Illustration|EmptyStatePreviewActivity140',
    component: EmptyStatePreviewActivity140,
    parameters: {
        notes:
            "`import EmptyStatePreviewActivity140 from 'box-ui-elements/es/illustration/EmptyStatePreviewActivity140';`",
    },
};
